import { SearchMetadata } from "@nerdjs/nerd-core";
import {
  Project_Entity,
  Task_Entity,
  Timer_Entity,
  User_Entity,
} from "../../kronos-kit/entities";
import { kronosApi } from "./kronosApi";

export const kronosEndpoints = kronosApi.injectEndpoints({
  endpoints: (build) => ({
    getKronosProjects: build.query<
      Project_Entity[],
      Record<string, unknown> | void
    >({
      query: (args) => ({
        url: "projects",
        params: args,
      }),
      providesTags: ["kronosProjects"],
    }),
    createKronosProject: build.mutation<
      Project_Entity,
      Partial<Project_Entity>
    >({
      query: (body) => ({
        method: "POST",
        url: "projects",
        body,
      }),
      invalidatesTags: ["kronosProjects"],
    }),
    updateKronosProject: build.mutation<
      void,
      { id: number; body: Partial<Project_Entity> }
    >({
      query: ({ id, body }) => ({
        method: "PUT",
        url: `projects/${id}`,
        body,
      }),
      invalidatesTags: ["kronosProjects"],
    }),
    deleteKronosProject: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `projects/${id}`,
      }),
      invalidatesTags: ["kronosProjects"],
    }),

    getKronosTasks: build.query<Task_Entity[], Record<string, unknown> | void>({
      query: (args) => ({
        url: "tasks",
        params: args,
      }),
      providesTags: ["kronosTasks"],
    }),
    createKronosTask: build.mutation<Task_Entity, Partial<Task_Entity>>({
      query: (body) => ({
        method: "POST",
        url: "tasks",
        body,
      }),
      invalidatesTags: ["kronosTasks"],
    }),
    updateKronosTask: build.mutation<
      void,
      { id: number; body: Partial<Task_Entity> }
    >({
      query: ({ id, body }) => ({
        method: "PUT",
        url: `tasks/${id}`,
        body,
      }),
      invalidatesTags: ["kronosTasks"],
    }),
    deleteKronosTask: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `tasks/${id}`,
      }),
      invalidatesTags: ["kronosTasks"],
    }),

    getKronosUsers: build.query<User_Entity[], Record<string, unknown> | void>({
      query: (args) => ({
        url: "users",
        params: args,
      }),
      providesTags: ["kronosUsers"],
    }),
    createKronosUser: build.mutation<User_Entity, Partial<User_Entity>>({
      query: (body) => ({
        method: "POST",
        url: "users",
        body,
      }),
      invalidatesTags: ["kronosUsers"],
    }),
    updateKronosUser: build.mutation<
      void,
      { id: number; body: Partial<User_Entity> }
    >({
      query: ({ id, body }) => ({
        method: "PUT",
        url: `users/${id}`,
        body,
      }),
      invalidatesTags: ["kronosUsers"],
    }),
    deleteKronosUser: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `users/${id}`,
      }),
      invalidatesTags: ["kronosUsers"],
    }),

    getKronosTimers: build.query<
      Timer_Entity[],
      Record<string, unknown> | void
    >({
      query: (args) => ({
        url: "timers",
        params: args,
      }),
      providesTags: ["kronosTimers"],
    }),
    getKronosCurrentTimer: build.query<Timer_Entity, void>({
      query: () => "timers/current",
      providesTags: ["kronosTimers"],
    }),
    getKronosTimersSearchMetadata: build.query<SearchMetadata, void>({
      query: () => "timers/searchMetadata",
      providesTags: ["kronosTimerSearchMetadata"],
    }),
    createKronosTimer: build.mutation<Timer_Entity, Partial<Timer_Entity>>({
      query: (body) => ({
        method: "POST",
        url: "timers",
        body,
      }),
      invalidatesTags: ["kronosTimers"],
    }),
    updateKronosTimer: build.mutation<
      void,
      { id: number; body: Partial<Timer_Entity> }
    >({
      query: ({ id, body }) => ({
        method: "PUT",
        url: `timers/${id}`,
        body,
      }),
      invalidatesTags: ["kronosTimers"],
    }),
    deleteKronosTimer: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `timers/${id}`,
      }),
      invalidatesTags: ["kronosTimers"],
    }),
  }),
});

export const {
  useGetKronosProjectsQuery,
  useCreateKronosProjectMutation,
  useUpdateKronosProjectMutation,
  useDeleteKronosProjectMutation,
  useGetKronosTasksQuery,
  useCreateKronosTaskMutation,
  useUpdateKronosTaskMutation,
  useDeleteKronosTaskMutation,
  useGetKronosUsersQuery,
  useCreateKronosUserMutation,
  useUpdateKronosUserMutation,
  useDeleteKronosUserMutation,
  useGetKronosTimersQuery,
  useGetKronosCurrentTimerQuery,
  useGetKronosTimersSearchMetadataQuery,
  useCreateKronosTimerMutation,
  useUpdateKronosTimerMutation,
  useDeleteKronosTimerMutation,
} = kronosEndpoints;
